<template>
  <div class="row">
    <div class="col-lg-4 style-select">
      <h4>
        Select Customer:
        <el-select
          class="select-info tab"
          placeholder="Single Select"
          v-model="selects.selectCustomer"
          @change="filterCustomer()"
        >
          <el-option
            v-for="option in selects.customers"
            class="select-info"
            :value="option.value"
            :label="option.label"
            :key="option.label"
          ></el-option>
        </el-select>
      </h4>
    </div>
    <div class="col-lg-4 style-select">
      <h4>
        Select Region:
        <el-select
          class="select-info tab"
          placeholder="Single Select"
          :disabled="disableRegion"
          @change="filterRegion()"
          v-model="selects.selectRegion"
        >
          <el-option
            v-for="option in selects.regions"
            class="select-info"
            :value="option.value"
            :label="option.label"
            :key="option.label"
          ></el-option>
        </el-select>
      </h4>
    </div>
    <div class="col-lg-4 style-select">
      <h4>
        Select Route:
        <el-select
          class="select-info tab"
          placeholder="Single Select"
          :disabled="disableRoute"
          @change="filterRoute()"
          v-model="selects.selectRoute"
        >
          <el-option
            v-for="option in selects.routes"
            class="select-info"
            :value="option.value"
            :label="option.label"
            :key="option.label"
          ></el-option>
        </el-select>
      </h4>
    </div>
    <div class="col-lg-12">
      <hr />
    </div>
    <div class="col-md-12">
      <card card-body-classes="table-full-width">
        <h4 slot="header" class="card-title">List of Pickup Points</h4>
        <div>
          <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
            <base-input label="rows visible">
            <el-select
              class="select-info mb-3 pagination-select"
              v-model="pagination.perPage"
              placeholder="Per page"
            >
              <el-option
                class="select-info"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
            </base-input>
            <base-input>
              <el-input
                type="search"
                class="mb-3 search-input"
                clearable
                prefix-icon="el-icon-search"
                placeholder="Search records"
                v-model="searchQuery"
                aria-controls="datatables"
              ></el-input>
            </base-input>
          </div>
          <el-table :data="queriedData" @selection-change="handleSelectionChange"  :header-cell-style="{
              background: 'transparent',
              border: 'none',
              borderBottom: '0.5px solid #3d3f51',
            }"
            :cell-style="{
              border: 'none',
              borderBottom: '0.5px solid #3d3f51',
            }">
            <el-table-column
              min-width="100"
              sortable
              align="center"
              label="Customer"
              property="CustName"
            ></el-table-column>
            <el-table-column
              min-width="90"
              sortable
              align="center"
              label="Region"
              property="RegionName"
            ></el-table-column>
            <el-table-column
              min-width="100"
              sortable
              align="center"
              label="Route"
              property="RouteName"
            ></el-table-column>
            <el-table-column
              v-if="false"
              min-width="100"
              sortable
              align="center"
              label="Pickup ID"
              property="PickupID"
            ></el-table-column>
            <el-table-column
              min-width="100"
              sortable
              align="center"
              label="Pickup Name"
              property="PickupName"
            ></el-table-column>
            <el-table-column type="selection" width="55"></el-table-column>
          </el-table>
        </div>
        <div
          slot="footer"
          class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
        >
          <div class>
            <p class="card-category">Showing {{ from + 1 }} to {{ to }} of {{ total }} entries</p>
          </div>
          <base-pagination
            class="pagination-no-border"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          ></base-pagination>
        </div>
      </card>
    </div>
    <div class="col-lg-12 text-right">
      <base-button type="primary" @click="generateQR()">Generate QR Code</base-button>
    </div>
  </div>
</template>

<script>
import { BasePagination } from "src/components";
import { Table, TableColumn, Select, Option } from "element-ui";
import Fuse from "fuse.js";
import swal from "sweetalert2";
import jsPDF from "jspdf";
import QRCode from "qrcode";
import axios from "axios";

export default {
  components: {
    BasePagination,
    [Select.name]: Select,
    [Option.name]: Option,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    QRCode
  },

  computed: {
    /***
     * Returns a page from the searched data or the whole data. Search is performed in the watch section below
     */
    queriedData() {
      let result = this.tableData;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    }
  },

  data() {
    return {
      options: {
        cellSize: 8,
        correctLevel: "H",
        data: "hello, world"
      },
      selects: {
        selectCustomer: "",
        selectRegion: "",
        selectRoute: "",
        customers: [{ value: "All", label: "All" }],
        regions: [{ value: "All", label: "All" }],
        routes: [{ value: "All", label: "All" }]
      },
      disableRegion: true,
      disableRoute: true,
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0
      },
      searchQuery: "",
      propsToSearch: ["PickupName"],
      tableData: [],
      storeData: [],
      multipleSelection: [],
      searchedData: [],
      fuseSearch: null,
      src2: require("@/assets/img/afes.png")
    };
  },

  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    filterCustomer() {
      const CUSTOMER = this.selects.selectCustomer;
      this.tableData = [];
      console.log(CUSTOMER);
      this.selects.regions = [{ value: "All", label: "All" }];

      if (CUSTOMER != "All") {
        for (let i = 0; i < this.storeData.length; i++) {
          if (CUSTOMER == this.storeData[i].CustName) {
            this.tableData.push(this.storeData[i]);

            let select = {
              label: this.storeData[i].RegionName,
              value: this.storeData[i].RegionName
            };
            this.selects.regions.push(select);
          }
        }

        this.selects.regions = [
          ...new Set(this.selects.regions.map(itm => JSON.stringify(itm)))
        ].map(i => JSON.parse(i));

        this.disableRegion = false;
      } else {
        this.tableData = this.storeData;
        this.selects.selectRegion = "All";
        this.disableRegion = true;
        this.disableRoute = true;
      }
    },
    filterRegion() {
      const CUSTOMER = this.selects.selectCustomer;
      const REGION = this.selects.selectRegion;
      this.tableData = [];

      this.selects.routes = [{ value: "All", label: "All" }];

      if (REGION != "All") {
        for (let i = 0; i < this.storeData.length; i++) {
          if (
            CUSTOMER == this.storeData[i].CustName &&
            REGION == this.storeData[i].RegionName
          ) {
            this.tableData.push(this.storeData[i]);

            let select = {
              label: this.storeData[i].RouteName,
              value: this.storeData[i].RouteName
            };
            this.selects.routes.push(select);
          }
        }
        this.selects.routes = [
          ...new Set(this.selects.routes.map(itm => JSON.stringify(itm)))
        ].map(i => JSON.parse(i));
        this.disableRoute = false;
      } else {
        for (let i = 0; i < this.storeData.length; i++) {
          if (CUSTOMER == this.storeData[i].CustName) {
            this.tableData.push(this.storeData[i]);
          }
        }
        this.selects.selectRoute = "All";
        this.disableRoute = true;
      }
    },
    filterRoute() {
      const CUSTOMER = this.selects.selectCustomer;
      const REGION = this.selects.selectRegion;
      const ROUTE = this.selects.selectRoute;
      this.tableData = [];

      if (ROUTE != "All") {
        for (let i = 0; i < this.storeData.length; i++) {
          if (
            CUSTOMER == this.storeData[i].CustName &&
            REGION == this.storeData[i].RegionName &&
            ROUTE == this.storeData[i].RouteName
          ) {
            this.tableData.push(this.storeData[i]);
          }
        }
      } else {
        for (let i = 0; i < this.storeData.length; i++) {
          if (
            CUSTOMER == this.storeData[i].CustName &&
            REGION == this.storeData[i].RegionName
          ) {
            this.tableData.push(this.storeData[i]);
          }
        }
      }
    },
    getPickupList() {
      this.$http.get(":9991/api/v1/report/listPickup").then(res => {
        console.log(res.message);
        let response = res.message;

        for (let i = 0; i < response.length; i++) {
          this.tableData.push(response[i]);
          this.storeData.push(response[i]);
          let select = {
            value: response[i].CustName,
            label: response[i].CustName
          };
          this.selects.customers.push(select);
        }
        this.selects.customers = [
          ...new Set(this.selects.customers.map(itm => JSON.stringify(itm)))
        ].map(i => JSON.parse(i));
      });
    },
    async generateQR() {
      const image = new Image();
      image.src = require("@/assets/img/afes.png");
      image.onload = () => {
        this.options = Object.assign({}, this.options, {
          logo: {
            image
          }
        });
      };

      let doc = jsPDF({
        orientation: "potrait",
        format: [1070, 1240]
      });

      doc.setFontSize(60);
      doc.setFontType("bold");

      let QRs = [];

      for (let i = 0; i < this.multipleSelection.length; i++) {
        QRs.push(
          QRCode.toDataURL(this.multipleSelection[i].PickupID)
            .then(url => {
              let obj = {};
              obj["PickupID"] = url;
              obj["PickupName"] = this.multipleSelection[i].PickupName;
              return obj;
            })
            .catch(err => {
              console.error(err);
            })
        );
      }
      Promise.all(QRs).then(QR => {
        for (let i = 0; i < QR.length; i++) {
          let pickupName = QR[i].PickupName.split(" ");
          pickupName.push(" ");
          pickupName.push(" ");
          pickupName.push(" ");
          pickupName.push(" ");
          pickupName.push(" ");
          console.log(pickupName);
          var img = new Image();
          img.src = require("@/assets/img/afes.png");
          doc.addImage(QR[i].PickupID, "JPEG", -20, -40, 420, 420);
          doc.addImage(img, "JPEG", 0, 340, 90, 80);
          if (pickupName.length < 3) {
            doc.text(pickupName[0] + " " + pickupName[1], 230, 380, "center");
          } else if (pickupName.length < 5) {
            doc.text(pickupName[0] + " " + pickupName[1], 230, 380, "center");
            doc.text(pickupName[2] + " " + pickupName[3], 230, 405, "center");
          } else {
            doc.text(pickupName[0] + " " + pickupName[1], 230, 380, "center");
            doc.text(pickupName[2] + " " + pickupName[3], 230, 405, "center");
            doc.text(pickupName[4] + " " + pickupName[5], 230, 430, "center");
          }
          if (i != QR.length - 1) {
            doc.addPage();  
          }
        }
        doc.save(`QR.pdf`);
      });
    }
  },

  created() {
    this.getPickupList();
  },
  mounted() {
    // Fuse search initialization.
    this.fuseSearch = new Fuse(this.tableData, {
      keys: ["PickupName"],
      threshold: 0.3
    });
  },
  watch: {
    /**
     * Searches through the table data by a given query.
     * NOTE: If you have a lot of data, it's recommended to do the search on the Server Side and only display the results here.
     * @param value of the query
     */
    searchQuery(value) {
      let result = this.tableData;
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    }
  }
};
</script>
<style lang="scss" scoped>
.inline {
  margin-top: 1.5%;
  margin-bottom: 1%;
}
hr {
  margin-top: 0%;
}
.style-date {
  margin-bottom: 1%;
}
.style-select {
  padding-top: 1%;
}
</style>